import * as States from "../../../data/states";
import { ExtendableSelectorProps, Selector } from "./selector";

const stateOptions = States.states.map(og => ({ id: og.abbreviation, name: og.name }));

export const StateSelector: React.FC<ExtendableSelectorProps> = ({ ...selectorProps }) => {
  return <Selector options={stateOptions} emptyOption={{ id: "", name: "Select a State" }} {...selectorProps} />;
};
